
import {getThunder} from '@/lib/utils/thunder';

export default {
    'news:pageShowLog'(foo, {getState}) {
        const thunder = getThunder();
        thunder.send({
            tid: 126,
            cst: 1,
            logInfo: 'landing',
            logExtra: {
                flow: 2,
                st: 'news',
                source: getState('common.isBjh'),
                login: +getState('common.isLogin'),
                appId: getState('article.itemData.infoBaiJiaHao.link')
            }
        });
        thunder.send({
            tid: 10814,
            cst: 1,
            logInfo: 'show'
        });
    },
    'backTop:showLog'(foo) {
        const thunder = getThunder();
        thunder.send({
            tid: 133,
            cst: 1,
            logInfo: 'back_to_top'
        });
    },
    'backTop:clkLog'(foo) {
        const thunder = getThunder();
        thunder.send({
            tid: 138,
            cst: 2,
            logInfo: 'back_to_top'
        });
    },
    'recentArticle:showLog'(foo) {
        const thunder = getThunder();
        thunder.send({
            tid: 135,
            cst: 1,
            logInfo: 'recent_article'
        });
    },
    'recentArticle:clkLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 147,
            cst: 2,
            logInfo: 'recent_article',
            logExtra: {
                pos: data && data.pos
            }
        });
    },
    'relatedNews:showLog'(foo) {
        const thunder = getThunder();
        thunder.send({
            tid: 136,
            cst: 1,
            logInfo: 'related_news'
        });
    },
    'relatedNews:clkLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 148,
            cst: 2,
            logInfo: 'related_news',
            logExtra: {
                pos: data && data.pos
            }
        });
    },
    'topBar:logoClkLog'(foo) {
        const thunder = getThunder();
        thunder.send({
            tid: 139,
            cst: 2,
            logInfo: 'head_logo'
        });
    },
    'topBar:menuClkLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 142,
            cst: 2,
            logInfo: 'head_menu',
            logExtra: {
                type: data && data.type
            }
        });
    },
    'topBar:usrMenuShowLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 131,
            cst: 1,
            logInfo: 'usr_menu'
        });
    },
    'topBar:usrMenuClkLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 146,
            cst: 2,
            logInfo: 'usr_menu',
            logExtra: {
                type: data && data.type,
                pos: data && data.pos
            }
        });
    },
    'video:showLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 950,
            cst: 1,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid
            }
        });
    },
    'video:playLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 951,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'starton'
            }
        });
    },
    'video:pauseLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 952,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'pause'
            }
        });
    },
    'video:replayLog'(data) {
        const thunder = getThunder();
        thunder.send({
            tid: 953,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid: data && data.vid,
                state: 'replay'
            }
        });
    },
    'video:endLog'(data) {
        const {vid, duration} = data || {};
        const thunder = getThunder();
        thunder.send({
            tid: 954,
            cst: 2,
            logInfo: 'main_video',
            logExtra: {
                vid,
                state: 'end',
                duration
            }
        });
    },
    'audio:showLog'(data) {
        const {songid, fileDuration} = data;
        const thunder = getThunder();
        thunder.send({
            tid: 2118,
            cst: 2,
            logInfo: 'main_real_audio_show',
            logExtra: {
                songid,
                'file_duration': fileDuration
            }
        });
    },
    'audio:playLog'(data) {
        const {songid, fileDuration} = data;
        const thunder = getThunder();
        thunder.send({
            tid: 2119,
            cst: 2,
            logInfo: 'main_real_audio_play',
            logExtra: {
                songid,
                'file_duration': fileDuration
            }
        });
    },
    'audio:pauseLog'(data) {
        const {songid, fileDuration} = data;
        const thunder = getThunder();
        thunder.send({
            tid: 2120,
            cst: 2,
            logInfo: 'main_real_audio_pause',
            logExtra: {
                songid,
                'file_duration': fileDuration
            }
        });
    },
    'readSrc:showLog'() {
        const thunder = getThunder();
        thunder.send({
            tid: 132,
            cst: 1,
            logInfo: 'readsrc'
        });
    },
    'readSrc:clkLog'() {
        const thunder = getThunder();
        thunder.send({
            tid: 137,
            cst: 2,
            logInfo: 'readsrc'
        });
    },
    'changan:showLog'() {
        const thunder = getThunder();
        thunder.send({
            tid: 11529,
            cst: 1,
            logInfo: 'changan_landingpc_show'
        });
    },
    'ttsLog:click'(value) {
        const thunder = getThunder();
        thunder.send({
            tid: 11548,
            cst: 2,
            logInfo: 'tts_click',
            logExtra: {
                type: 'tts_button_click',
                value
            }
        });
    },
    'ttsLog:btnShow'() {
        const thunder = getThunder();
        thunder.send({
            tid: 11547,
            cst: 2,
            logInfo: 'tts_show',
            logExtra: {
                type: 'tts_player_show'
            }
        });
    }
};
